<h1 mat-dialog-title>Adicionar desconto personalizado</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: '700px';">
    <form [formGroup]="produtoDescontoForm">
        <div class="borda">
            <div class="row">
                <div class="col-sm">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Nome do grupo</mat-label>
                        <input type="text" matInput formControlName="nome" maxlength="100"
                            (keypress)="omit_special_char($event)" [matAutocomplete]="auto"
                            (ngModelChange)="onChangeNomeProduto($event)">
                        <mat-hint *ngIf="bCaracterEspecial" align="start" style="color: red;"> Não são permitidos
                            acentos ou
                            caracteres especiais </mat-hint>
                    </mat-form-field>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let prod of produtos" [value]="prod.Nome"
                            (onSelectionChange)="detalharProduto(prod)">
                            {{prod.Nome}} - Q.M.: {{prod.QuantidadeMinima}} - {{prod.ProdutosString}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Nome</mat-label>
                    <input type="text" matInput formControlName="nome" maxlength="50" readonly>
                </mat-form-field>
            </div>

            <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Quantidade mínima para o desconto</mat-label>
                    <input type="number" matInput formControlName="quantidadeMinima" max="9999999" readonly>
                    <mat-error *ngIf="f.quantidadeMinima.errors?.required">
                        Campo obrigatório
                    </mat-error>
                    <mat-error *ngIf="f.quantidadeMinima.errors?.min">
                        A quantidade mínima é 1
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Desconto em %</mat-label>
                    <input matInput currencyMask
                        [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                        formControlName="porcentagemDesconto" required>
                    <mat-hint align="end" *ngIf="f.porcentagemDesconto.value !== 'produtorRural'">Desconto máximo de
                        50,00%
                    </mat-hint>
                    <mat-error *ngIf="f.porcentagemDesconto.errors?.required">
                        Campo obrigatório
                    </mat-error>
                    <mat-error *ngIf="f.porcentagemDesconto.errors?.min">
                        O mínimo é 1%
                    </mat-error>
                    <mat-error *ngIf="f.porcentagemDesconto.errors?.max">
                        O máximo é 50,00%
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-sm">
                Produtos: {{f.produtosString.value}}
            </div>
        </div>
    </form>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="warn" (click)="cancelar()">
            <mat-icon>clear</mat-icon> Cancelar
        </button>
        <button mat-flat-button color="primary" (click)="adicionarPromocao()">
            <mat-icon>check</mat-icon> Adicionar promoção
        </button>
    </section>
</div>